"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.events = {};
    }
    EventEmitter.prototype.on = function (event, callback) {
        if (typeof this.events[event] !== 'object') {
            this.events[event] = [];
        }
        this.events[event].push(callback);
    };
    EventEmitter.prototype.off = function (event, callback) {
        this.removeListener(event, callback);
    };
    EventEmitter.prototype.removeListener = function (event, callback) {
        if (typeof this.events[event] === 'object') {
            var index = this.events[event].indexOf(callback);
            if (index !== -1) {
                this.events[event].splice(index, 1);
            }
        }
    };
    EventEmitter.prototype.removeAllListeners = function () {
        this.events = {};
    };
    EventEmitter.prototype.emit = function (event, value) {
        if (typeof this.events[event] === 'object') {
            this.events[event]
                .filter(function (cb) { return cb != null; })
                .forEach(function (cb) { return cb(value); });
        }
    };
    return EventEmitter;
}());
exports.default = EventEmitter;
//# sourceMappingURL=eventEmitter.js.map